import { useMemo } from "react";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import { IDataDashboardReceituario } from "../../../../../types/api/receituarioAgronomico/dashboard-receituario";
import { Bar } from "react-chartjs-2";


export default function CardReceitas({
    dataDashboard
}: CardReceitasProps) {

    const labels = useMemo(() => (dataDashboard.receitas_emitidas_restantes.map(item => item.loja_nome)), [dataDashboard]);

    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        plugins: {
            legend: {
                position: 'bottom' as const,
            },
            title: {
                display: true,
                text: 'Receitas Emitidas X Restantes',
            },
        },
        elements: {
            line: {
                tension: 0.4
            }
        },
         scales: {
        x: {
            stacked: true
        },
        y: {
            stacked: true, 
            beginAtZero: true,
        }
    }
    }), []);

    const dataGrafico = useMemo(() => ({
        labels,
        datasets: [
            {
                label: 'Receitas emitidas',
                data: dataDashboard.receitas_emitidas_restantes.map(item => item.total_receitas_emitidas), // Valores maiores para pedidos
                borderColor: '#4B89DC',
                backgroundColor: '#4B89DC',
                fill: true
            },
            {
                label: 'Receitas restantes',
                data: dataDashboard.receitas_emitidas_restantes.map(item => item.total_receitas_restantes), // Valores maiores para pedidos
                borderColor: '#dc4b4b',
                backgroundColor: '#dc4b4b',
                fill: true
            },
        ],
    }), [labels, dataDashboard]);
    return (
        <PaperBox style={{ height: '100%' }} p={2}>
            <Bar options={options} data={dataGrafico} />
        </PaperBox>
    )
}

interface CardReceitasProps {
    dataDashboard: IDataDashboardReceituario;
}
